<template>
    <footer>
        <!-- <div class="kingster-footer-wrapper ">
            <div class="kingster-footer-container kingster-container clearfix ">
                <div class="kingster-footer-column kingster-item-pdlr kingster-column-15 col-12 col-md-3 mb-1">
                    <div id="text-2" class="  widget widget_text kingster-widget">
                        <div class="textwidget">
                            <p align="center"><img src="./../assets/logo-white.png" alt="" width="70%"></p>
                             
                            <p align="center"><span style="font-size: 15px; color: #ffffff;">+20-19050</span><br>
                                <span class="gdlr-core-space-shortcode" style="margin-top: -20px ;"></span>
                                <a style="font-size: 15px; color: #ffffff;"
                                    href="mailto:public.relations@su.edu.eg">public.relations@su.edu.eg</a></p>
                            <div class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-left-align">
                                <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                                    style="border-color: #343434 ;border-width: 2px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kingster-footer-column kingster-item-pdlr kingster-column-15 col-12 col-md-3 mb-1">
                    <div id="gdlr-core-custom-menu-widget-2"
                        class="widget widget_gdlr-core-custom-menu-widget kingster-widget">
                        <h3 class="kingster-widget-title">SU Life</h3><span class="clear"></span>
                        <div class="menu-accounting-menu-container">
                            <ul id="menu-accounting-menu"
                                class="gdlr-core-custom-menu-widget gdlr-core-menu-style-plain">
                                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7964"><a
                                        href="http://su.edu.eg/index.php/dorms_arish_home/" target="_blank">DORMS ARISH</a>
                                </li>
                                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7965"><a
                                        href="http://su.edu.eg/index.php/kantara_dorms/"  target="_blank">DORMS KANTARA</a>
                                </li>
                                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7966"><a
                                        href="http://su.edu.eg/index.php/news__events/"  target="_blank">NEWS &amp; EVENTS</a>
                                </li>
                                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7967"><a
                                        href="http://su.edu.eg/index.php/su_store/"  target="_blank">SU STORE</a></li>
                                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7968"><a
                                        href="http://su.edu.eg/index.php/a-transportation/">TRANSPORTATION</a>
                                </li>
                                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7969"><a
                                        href="http://su.edu.eg/index.php/su_go_cashless/"  target="_blank">CASHLESS</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="kingster-footer-column kingster-item-pdlr kingster-column-15 col-12 col-md-3 mb-1">
                    <div id="gdlr-core-custom-menu-widget-3"
                        class="widget widget_gdlr-core-custom-menu-widget kingster-widget">
                        <h3 class="kingster-widget-title">Study at SU</h3><span class="clear"></span>
                        <div class="menu-campus-life-container">
                            <ul id="menu-campus-life" class="gdlr-core-custom-menu-widget gdlr-core-menu-style-plain">
                                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-5717"><a
                                        href="http://su.edu.eg/index.php/arish-homepage/"  target="_blank">ARISH CAMPUS</a></li>
                                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-5716"><a
                                        href="http://su.edu.eg/index.php/kantra-homepage/"  target="_blank">KANTARA CAMPUS</a></li>
                                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-8619"><a
                                        href="http://su.edu.eg/index.php/gallery_/"  target="_blank">GALLERY</a></li>
                                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-9378"><a
                                        href="http://su.edu.eg/vt"  target="_blank">VIRTUAL TOUR</a></li>
                                <li class="menu-item menu-item-type-custom menu-item-object-custom menu-item-9982"><a
                                        href="http://su.edu.eg/index.php/career_opportunities/"  target="_blank">CAREER OPPORTUNITIES</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="kingster-footer-column kingster-item-pdlr kingster-column-15 col-12 col-md-3 mb-1">
                    <div id="gdlr-core-custom-menu-widget-4"
                        class="widget widget_gdlr-core-custom-menu-widget kingster-widget">
                        <h3 class="kingster-widget-title">Research</h3><span class="clear"></span>
                        <div class="menu-finance-menu-container">
                            <ul id="menu-finance-menu" class="gdlr-core-custom-menu-widget gdlr-core-menu-style-plain">
                                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7970"><a
                                        href="http://su.edu.eg/index.php/su_research/"  target="_blank">SU RESEARCH</a></li>
                                <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7971"><a
                                        href="http://su.edu.eg/index.php/research_published/"  target="_blank">RESEARCH
                                        PUBLISHED</a></li>
                                        <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7972">FOLLOW US<br/>
                                            <a href="https://play.google.com/store/apps/details?id=com.sidieg.sinaiUniversity" target="_blank"><img src="./../assets/google-play.png"  class="mt-2" alt="Google play" width="200px"/></a><br/>
                                             <img src="./../assets/Apple-app.png"  class="mt-2" alt="ComingSoon" width="200px" v-b-tooltip.hover title="Coming Soon"/>


                                        </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="kingster-copyright-wrapper">
            <div class="kingster-copyright-container kingster-container clearfix">
                <div class="kingster-copyright-left kingster-item-pdlr text-center">UNICode Portal @Copyright All Right Reserved 2020 <a href="#">Odyssey Technology</a>
                </div>
                
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'Footer'

    }
</script>

<style>
footer{
        background: #181818;
        color: #fff;
}
.kingster-footer-wrapper {
    padding-top: 40px;
    padding-bottom: 50px;
}
.kingster-footer-wrapper .kingster-footer-container {
    overflow: hidden;
}
.kingster-column-15 {
    float: left;
    width: 25%;
}
.kingster-footer-wrapper .kingster-widget-title {
    font-size: 13px;
    text-transform: uppercase;
    border-bottom-width: 0.5px;
    border-bottom-style: solid;
    padding-bottom: 15px;
    margin-bottom: 26px;
    margin-right: 34px;
    border-color: #4d4b4b;
}
footer ul {
     margin-left: 0px;
    }
footer ul li {
    list-style: none;
    padding-bottom: 10px;
  
}
footer ul li a{
    list-style: none;
    color: #999;
   font-weight: 100;
   font-size: 14;
}
footer ul li a:hover{
     color: #999;
}
.kingster-copyright-wrapper{
    background: #202020;
    padding: 15px;
    font-size: 10px;
    color: #999;
}

</style>